import { Button, styled } from "@mui/material";
import {  ComponentPropsWithoutRef, FC } from "react";

export interface SubmitGradientButtonProps extends ComponentPropsWithoutRef<typeof Button>{
}
const  SubmitGradientButton:FC<SubmitGradientButtonProps> = (props) => {
  return <StyledButton {...props}/>
}
const StyledButton = styled(Button)(()=>({
  width: "100%",
  maxHeight: "100%",
  borderRadius: "22px",
  padding: "12px 8px 12px 8px",
  fontFamily: "Manrope, sans-serif",
  fontSize: "12px",
  lineHeight: "16px",
  fontWeight: 400,
  letterSpacing: "0.4px",
  textTransform: "uppercase",
  color: "var(--white)",
  background: "var(--btn-gradient)",
  transition: "all 0.6s ease",

  "&:hover": {
    textDecoration: "none",
    boxShadow: "var(--btns-hover-shadow)",
  },
}))
export default SubmitGradientButton

